import React, { FC, ReactNode } from "react";
import ReactHtmlParser from "react-html-parser";
import kebabCase from "lodash/kebabCase";

import { useJuneSoComponentContext } from "@stadium/services/june-analytics";

import { ExternalButton } from "@sharedComponents/buttons";

import styles from "./main.module.scss";

interface DefaultObjType {
  [key: string]: any;
}

type TextBannerWithBtnAndBgImgProps = {
  data: any;
  editingAllowed: boolean;
  children: ReactNode;
  content: { bgImg: string; buttonsList: string[] };
};

const emptyObj: DefaultObjType = {};

const TextBannerWithBtnAndBgImg: FC<TextBannerWithBtnAndBgImgProps> = ({
  data,
  editingAllowed,
  children,
  content,
}) => {
  const { buttonsList, bgImg } = content || emptyObj;
  const { jsonContent, imageOne } = data || emptyObj;
  const { rte_content = "", buttons_list = buttonsList } =
    (jsonContent && JSON.parse(jsonContent)) || emptyObj;
  const { componentName } = useJuneSoComponentContext();

  return (
    <div
      className={styles.heroSliceContainer}
      style={{ backgroundImage: `url(${imageOne || bgImg})` }}
    >
      <div className={styles.bannerContainer}>
        <div className={styles.heroSliceContentArea}>
          <div className={styles.heroContentContainer}>
            {rte_content && ReactHtmlParser(rte_content)}
          </div>
          <div className={styles.heroSliceCtaRow}>
            {buttons_list.map(({ button_link, button_text, button_style, target }) => (
              <ExternalButton
                href={button_link}
                className={styles.heroSliceButton}
                styleType={button_style}
                analytics={{
                  componentName: componentName ? `${componentName}-hero-slice` : "",
                  target: kebabCase(button_text),
                }}
                key={button_link}
                target={target}
                showExternalLinkIcon={target}
                title={button_text}
                tab-index="0"
              >
                {button_text}
              </ExternalButton>
            ))}
          </div>
        </div>
        {editingAllowed && children}
      </div>
    </div>
  );
};

export default TextBannerWithBtnAndBgImg;
